import http from "@/components/services/http-common";

export default class Api {
  getBranches = () => http.get('departments?departmentTypeCode=K00002&authorize=true')

  getEmployeeRotations = (month) => http.get(`employeeRotationDetails/by-month/${month}`)

  getEmployeesByDept = (storeCode) => http.get(`employees/dept/${storeCode}`)

  getWorkPlans = (storeCode, fromDate, toDate, type) => http.get('workplans', {
    params: {
      storeCode,
      fromDate,
      toDate,
      type
    }
  })

  createWorkPlan = (payload) => http.post('workplans', payload)

  getOvertimePlans = (storeCode, fromDate, toDate, type) => http.get('workplans', {
    params: {
      storeCode,
      fromDate,
      toDate,
      type
    }
  })

  createOvertimePlan = (payload) => http.post('workplans', payload)

  deleteWorkPlan = (employeeCode, workDate, type) => http.delete(`workplans/${employeeCode}/${workDate}`, {
    params: {
      type
    }
  })

  enroll = (employeeCode, workDate, checkin, checkout, type = 'shift') => http.get('workplans/enroll', {
    params: {
      employeeCode,
      workDate,
      checkin,
      checkout,
      type
    }
  })

  resetEnroll = (employeeCode, workdate) => http.delete('workplans/enroll', {
    params: {
      employeeCode,
      workdate
    }
  })
}
